// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"5c210b38","453":"d855a71b","500":"1c5c453f","549":"a287091b","850":"64fe52df"}[chunkId] + ".chunk.js";
};